import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class Testimonial extends Component {

	render() {

		let publicUrl = process.env.PUBLIC_URL + '/'
		let imagealt = 'image'

		return <div className="ltn__testimonial-area section-bg-1--- bg-image-top pt-115 pb-70" data-bs-bg={publicUrl + "assets/img/bg/20.jpg"}>
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="section-title-area ltn__section-title-2--- text-center">
							{/* <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">Our Testimonial</h6> */}
							<h1 className="section-title">Smart Ownership</h1>
						</div>
					</div>
				</div>
				<div className="row ltn__testimonial-slider-5-active slick-arrow-1">
					<div className="col-lg-4">
						<div className="ltn__testimonial-item ltn__testimonial-item-7">
							<div className="ltn__testimoni-info">
								<h5>Why Choose AVS for Farm Plots</h5>
								<p>
									{/* <i className="flaticon-left-quote-1" />  */}
									Our layouts are designed with long-term appreciation in mind. Every inch is planned for legal clarity, water access, and value growth over time.
								</p>
								<div className="ltn__testimoni-info-inner">
									{/* <div className="ltn__testimoni-img">
										<img src={publicUrl+"assets/img/testimonial/1.jpg"} alt="#" />
									</div> */}
									<div className="ltn__testimoni-name-designation">
										<label>Land Value First</label> <br />
										<label>Future-Ready Planning</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-4">
						<div className="ltn__testimonial-item ltn__testimonial-item-7">
							<div className="ltn__testimoni-info">
								<h5>Strategic Location Advantage</h5>
								<p>
									{/* <i className="flaticon-left-quote-1" />  */}
									All AVS projects are within 30–45 minutes of major highways and towns. We focus on sites with fast-improving infrastructure.
								</p>
								<div className="ltn__testimoni-info-inner">
									{/* <div className="ltn__testimoni-img">
										<img src={publicUrl+"assets/img/testimonial/1.jpg"} alt="#" />
									</div> */}
									<div className="ltn__testimoni-name-designation">
										<label>Close to the City</label> <br />
										<label>Yet Calm & Green</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-4">
						<div className="ltn__testimonial-item ltn__testimonial-item-7">
							<div className="ltn__testimoni-info">
								<h5>Build When You’re Ready</h5>
								<p>
									{/* <i className="flaticon-left-quote-1" />  */}
									We don’t rush you into construction. Our plots come with flexible timelines, clear boundaries, and support if you choose to build later.
								</p>
								<div className="ltn__testimoni-info-inner">
									{/* <div className="ltn__testimoni-img">
										<img src={publicUrl+"assets/img/testimonial/1.jpg"} alt="#" />
									</div> */}
									<div className="ltn__testimoni-name-designation">
										<label>Own. Grow. Build.</label> <br />
										<label>On Your Terms</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* <div className="col-lg-4">
			        <div className="ltn__testimonial-item ltn__testimonial-item-7">
			          <div className="ltn__testimoni-info">
			            <p><i className="flaticon-left-quote-1" /> 
			              Precious ipsum dolor sit amet
			              consectetur adipisicing elit, sed dos
			              mod tempor incididunt ut labore et
			              dolore magna aliqua. Ut enim ad min
			              veniam, quis nostrud Precious ips
			              um dolor sit amet, consecte</p>
			            <div className="ltn__testimoni-info-inner">
			              <div className="ltn__testimoni-img">
			                <img src={publicUrl+"assets/img/testimonial/4.jpg"} alt="#" />
			              </div>
			              <div className="ltn__testimoni-name-designation">
			                <h5>James Carter</h5>
			                <label>Selling Agents</label>
			              </div>
			            </div>
			          </div>
			        </div>
			      </div> */}
					{/*  */}
				</div>
			</div>
		</div>

	}
}

export default Testimonial